import { Link, Navigate } from 'react-router-dom';
import useFetch, { Status } from '../../../../../hooks/fetch.hook';
import { CompetitionApiModel } from '../../../models/competition.api-model';
import Spinner from '../../../../Shared/Spinner';
import GeneralError from '../../../../Shared/GeneralError';
import type ICompetition from '../../../../../models/pa-egna-ben/competition.model';

function processReceivedData(data: CompetitionApiModel[]): ICompetition[] {
  return data?.map((d) => CompetitionApiModel.mapToBusinessModel(d)) ?? [];
}

function Competitions() {
  // === STATE ===
  const [{ status, data, httpResponseStatusCode }] = useFetch<CompetitionApiModel[]>('/api/paegnaben/admin/competitions');

  // === VARIABLES ===
  const competitions = data ? processReceivedData(data) : undefined;

  // === RENDER ===
  if (status === Status.failed && httpResponseStatusCode === 401) {
    return <Navigate to="/session-utgangen" />;
  }
  if (status === Status.failed && httpResponseStatusCode === 403) {
    return <Navigate to="/atkomst-saknas" />;
  }

  return (
    <div>
      <h1>Tävlingar</h1>
      {status === Status.loading && <Spinner className="my-4 my-md-5" />}
      {status === Status.failed && <GeneralError errorText="Kunde inte hämta tävlingar" className="mb-4" />}
      {status === Status.success && (
        <table className="table">
          <thead>
            <tr>
              <th scope="col">Namn</th>
              <th scope="col">Tid</th>
              <th scope="col">
                <span className="visually-hidden">Åtgärder</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {competitions?.map((competition) => (
              <tr key={competition.id}>
                <th scope="row">{competition.name}</th>
                <td>
                  {competition.startTime.toISODate()} - {competition.endTime.toISODate()}
                </td>
                <td>
                  <Link to={`/tavlingar/${competition.id}/redigera`}>Redigera</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <Link to={'/tavlingar/lagg-till'} className="btn btn-primary">
        Lägg till tävling
      </Link>
    </div>
  );
}

export default Competitions;
